// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","modal":"Modal_modal__RajTW","button":"Modal_button__xPy0p","content":"Modal_content__0gsT8","actions":"Modal_actions__f+o3e"};